import { environment, BASE_URL } from "../environment/environment";
import axios from 'axios';

export const authenticateJira = async (databaseId, code, codeVerifier) => {
    const data = {
        databaseId: databaseId,
        code: code,
        redirect_uri: environment.jiraRedirectUri,
        code_verifier: codeVerifier,
    };

    try {
        const response = await axios.post(
            `${BASE_URL}/auth/jiraToken`, 
            data,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        localStorage.setItem('access_token', response.data.token);

        return response.data;
    } catch (error) {
        console.error('Error sending data to backend:', error.response?.data || error.message);
        throw error;
    }
};

export const redirectToJiraAuth = () => {
    window.location.href = '/auth/Jira';
  };


